// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentTableFooter__Uuq4q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  text-transform: uppercase;
  color: var(--inputs-default-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  width: 100%;
  padding: 0px 25px 25px 25px;
}
@media (max-width: 900px) {
  .equipmentTableFooter__Uuq4q {
    padding: 0px 15px 15px 15px;
  }
}

.equipmentTableFooterRight__UVNf7 {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
}

.actionButtonWrapper__u9ZcE {
  display: flex;
  align-items: center;
  gap: 25px;
}

.removeOrSaveButtonWrapper__VKVT5 button {
  width: unset;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTemplate/components/Footer/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,2BAAA;AAzEF;AA2EE;EAfF;IAgBI,2BAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxEF;;AA4EE;EACE,YAAA;AAzEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentTableFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n  text-transform: uppercase;\n  color: var(--inputs-default-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  width: 100%;\n  padding: 0px 25px 25px 25px;\n\n  @media (max-width: 900px) {\n    padding: 0px 15px 15px 15px;\n  }\n}\n\n.equipmentTableFooterRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-left: auto;\n}\n\n.actionButtonWrapper {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n\n.removeOrSaveButtonWrapper {\n  button {\n    width: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentTableFooter": `equipmentTableFooter__Uuq4q`,
	"equipmentTableFooterRight": `equipmentTableFooterRight__UVNf7`,
	"actionButtonWrapper": `actionButtonWrapper__u9ZcE`,
	"removeOrSaveButtonWrapper": `removeOrSaveButtonWrapper__VKVT5`
};
module.exports = ___CSS_LOADER_EXPORT___;
